import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bb6658b0")

_pushScopeId("data-v-bb6658b0")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("アカウント登録")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "ログインに使用するEメールアドレスとパスワードを入力してください。", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, "アカウント登録ボタンを押すと、確認のための6桁の番号がEメールに送信されます。", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("アカウント登録")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ログイン画面に戻る")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_page_description = _resolveComponent("page-description")
  const _component_icon_edit_box = _resolveComponent("icon-edit-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_link_text = _resolveComponent("link-text")
  const _component_vue_login_form = _resolveComponent("vue-login-form")
  const _component_vue_login_frame = _resolveComponent("vue-login-frame")
  const _directive_focus = _resolveDirective("focus")
  const _directive_enter = _resolveDirective("enter")

  return (_openBlock(), _createBlock(_component_vue_login_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_login_form, null, {
        default: _withId(() => [
          _createVNode("h1", null, [
            _createVNode(_component_logo),
            _hoisted_1
          ]),
          _createVNode(_component_page_description, null, {
            default: _withId(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_icon_edit_box, {
            class: "login-edit-box",
            icon: "envelope",
            title: "ログイン名",
            placeholder: "Eメールアドレス",
            modelValue: _ctx.userId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userId = $event)),
            validation: _ctx.submitted ? _ctx.userIdError : undefined,
            ref: "userIdRef"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_focus, 'userIdRef'],
            [_directive_enter, {focus:'nameRef'}]
          ]),
          _withDirectives(_createVNode(_component_icon_edit_box, {
            class: "login-edit-box",
            icon: "user-circle",
            title: "名前",
            placeholder: "名前(先生・スタッフの表示名称)",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.name = $event)),
            validation: _ctx.submitted ? _ctx.nameError : undefined,
            ref: "nameRef"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_enter, {focus:'passwordRef'}]
          ]),
          _withDirectives(_createVNode(_component_icon_edit_box, {
            class: "login-edit-box",
            icon: "lock",
            title: "パスワード",
            placeholder: "パスワード",
            inputType: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
            validation: _ctx.submitted ? _ctx.passwordError : undefined,
            ref: "passwordRef"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_enter, {focus:'confirmedPasswordRef'}]
          ]),
          _withDirectives(_createVNode(_component_icon_edit_box, {
            class: "login-edit-box",
            icon: "lock",
            title: "パスワード",
            placeholder: "パスワード(確認のため同じものを入力してください)",
            inputType: "password",
            modelValue: _ctx.confirmedPassword,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmedPassword = $event)),
            validation: _ctx.submitted ? _ctx.confirmedPasswordError : undefined,
            ref: "confirmedPasswordRef"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_enter, {click:'submitRef'}]
          ]),
          _createVNode(_component_normal_button, {
            class: "submit-button",
            state: "normal",
            ref: "submitRef",
            disabled: _ctx.requesting,
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_link_text, { link: "/login" }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})